export type ThemeMode = 'light' | 'dark';
export type StoredThemePreference = ThemeMode | null;

export const THEME_STORAGE_KEY = 'pwa-theme';

export function parseStoredThemePreference(value: string | null | undefined): StoredThemePreference {
  if (value === 'dark') return 'dark';
  if (value === 'light') return 'light';
  return null;
}

export function resolveThemeMode(
  stored: StoredThemePreference,
  prefersDark: boolean,
): ThemeMode {
  if (stored === 'dark' || stored === 'light') return stored;
  return prefersDark ? 'dark' : 'light';
}

export function readSystemPrefersDark(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}
